import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import * as yup from 'yup';
import { Formik } from 'formik';


const UpdatePhoneNumberModal = ({ onUpdatePhoneNumber, setOpen, open }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="update-phone-number-dialog"
      PaperProps={{
        className: 'border-radius-6 p-3 max-w-400'
      }}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle id="edit-timeline-dialog" className="flex-column w-full p-3">
        <div className="flex justify-between">
          <Typography variant="h5" className="uppercase">
            {'Update Phone Number'}
          </Typography>
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <Formik
        initialValues={{
          telephone: ''
        }}
        onSubmit={onUpdatePhoneNumber}
        validationSchema={yup.object({
          telephone: yup
            .string()
            .min(11, 'Enter valid phone number')
            .max(11, 'Enter valid phone number')
            .required('Field is required')
        })}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleSubmit,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit} noValidate className="w-full">
            <DialogContent className="p-3">
              <Grid container>
                <Grid item xs={12}>
                  <NumberFormat
                    customInput={TextField}
                    format="+# (###) ###-####"
                    required
                    fullWidth
                    label="Phone Number"
                    variant="outlined"
                    name="telephone"
                    value={values.telephone || null}
                    onValueChange={(value) => {
                      setFieldValue('telephone', String(value.floatValue));
                    }}
                    onBlur={handleBlur}
                    error={touched?.telephone && Boolean(errors?.telephone)}
                    helperText={touched?.telephone && errors?.telephone}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className="justify-between">
              <Button
                variant="outlined"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                color="primary"
                variant="contained"
              >
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default UpdatePhoneNumberModal;
